import SplitScreenContent from "../../components/SplitScreenContent";

export const porscheReparatur = {
  title: "Reparatur & Unfallinstandsetzung für Porsche",
  titleImageUrl: "porsche-engine.jpg",
  meta: {
    title:
      "Porsche Reparatur & Unfallinstandsetzung – Karosserie, Lack, Elektrik & Versicherung | WTM Sportwagen",
    description:
      "WTM Sportwagen repariert Ihren Porsche nach Herstellervorgaben: Karosserie, Lack, Fahrwerk, Elektrik & Airbag. Unfallinstandsetzung inkl. Gutachten & direkter Abwicklung mit der Versicherung. Hol-/Bringservice deutschlandweit.",
  },
  content: [
    {
      type: "hero_image",
      backgroundImage:
        "https://res.cloudinary.com/donwh3eei/image/upload/v1756324210/gallery/frank_kayser/L1013186_2_h85rol",
      headline: "Original. Sicher. Repariert. Wert erhalten.",
      description:
        "Ob Kratzer, Parkrempler oder struktureller Unfallschaden: Wir setzen Ihren Porsche technisch korrekt und optisch perfekt instand – nach Herstellervorgaben, mit dokumentierter Qualität.",
      hasVignette: true,
      overlayOpacity: 0.01,
    },
    {
      type: "text_section_hero",
      // headline: "Originalität bewahren. Sicherheit herstellen. Wert erhalten.",
      lead: "Ob Kratzer, Parkrempler oder struktureller Unfallschaden: Wir setzen Ihren Porsche technisch korrekt und optisch perfekt instand – nach Herstellervorgaben, mit dokumentierter Qualität.",
      highlight: "Originalgetreu repariert – wie am ersten Tag.",
      spacing: "tight_top_comfortable_bottom",
      size: "lg",
      variant: "primary",
      margin: false,
    },

    {
      type: "split_screen_layout",
      leftImage: "gallery/frank_kayser/L1013191_dwn62r",
      headline: "Porsche-Reparatur bei WTM",
      rightContent: (
        <SplitScreenContent
          headline="Originalgetreue Porsche-Reparatur"
          intro="Von der ersten Schadensbegutachtung bis zur finalen Qualitätskontrolle – wir setzen Ihren Porsche nach Herstellervorgaben instand. Originalität, Sicherheit und Werterhalt stehen dabei im Fokus.<br/><a href='/porsche-elektronik' class='hyperlink'>Für Fehler und Schäden elektronischer Natur finden Sie hier weitere Informationen</a>."
          padding="py-24 px-4 lg:px-24"
          blocks={[
            {
              type: "heading",
              text: "Herstellerprozesse & Originalteile",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Porsche-Farbcodes, fachgerechte Schweißtechnik, präzise Geometrieprüfung – jede Reparatur folgt den Herstellervorgaben für perfekte Ergebnisse und langfristigen Werterhalt.",
            },
            {
              type: "heading",
              text: "Alle Schadensarten",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Vom Steinschlag bis zum Strukturschaden – wir reparieren Karosserie, Lack, Fahrwerk und Elektronik fachgerecht und dokumentiert.",
            },
            {
              type: "heading",
              text: "Deutschlandweiter Service",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Versicherter Hol- und Bringservice deutschlandweit. Transparente Kommunikation und persönliche Betreuung während der gesamten Reparatur.",
            },
            {
              type: "component",
              component: "CallToActionWithModalV2",
              props: {
                headline: "Reparatur anfragen – wir beraten Sie persönlich",
                paragraph:
                  "Schaden an Ihrem Porsche? Senden Sie uns Fotos und Beschreibung. Wir beraten Sie zu Reparaturmöglichkeiten und Kosten.",
                darkMode: false,
                margin: false,
              },
            },
          ]}
        />
      ),
      imageAlt:
        "WTM Sportwagen Porsche-Reparatur - Professionell und originalgetreu",
      navbarHeight: 0,
    },

    {
      type: "split_screen_layout",
      leftImage: "gallery/frank_kayser/L1013283_1_l5rikn",
      headline: "Was wir reparieren",
      rightContent: (
        <SplitScreenContent
          headline="Von Kratzer bis Totalschaden"
          intro="Karosserie, Lack, Fahrwerk, Elektronik – wir setzen Ihren Porsche nach Herstellervorgaben instand. Vom Steinschlag bis zum strukturellen Unfallschaden."
          padding="py-24 px-4 lg:px-24"
          blocks={[
            {
              type: "heading",
              text: "Karosserie & Struktur",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Präzise Blech- und Strukturarbeiten. Fachgerechtes Schweißen, Kleben, Nieten – für originalgetreue Spaltmaße und perfekte Geometrie.",
            },
            {
              type: "heading",
              text: "Lackierung & Finish",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Spot-Repair, Teillackierung oder Ganzlackierung mit Porsche-Farbcodes. Staubarmes Kabinenfinish und professionelle Politur für perfekte Ergebnisse.",
            },
            {
              type: "heading",
              text: "Fahrwerk & Sicherheit",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Achsvermessung, Fahrwerks-Check, Airbag- und Crash-Elektronik. Alle sicherheitsrelevanten Systeme werden geprüft und fachgerecht instand gesetzt.",
            },
            {
              type: "heading",
              text: "Dokumentierte Qualität",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Lückenlose Fotodokumentation aller Arbeitsschritte, Prüfprotokolle und Qualitätskontrollen – für nachvollziehbare Ergebnisse und langfristigen Werterhalt.",
            },
          ]}
        />
      ),
      imageAlt: "WTM Sportwagen Porsche-Reparatur - Alle Bereiche",
      navbarHeight: 0,
    },

    {
      type: "split_screen_layout",
      leftImage: "gallery/frank_kayser/L1013428_1_ghbml3",
      headline: "Für alle Porsche-Modelle",
      rightContent: (
        <SplitScreenContent
          headline="Von Classic bis Modern"
          intro="Wir kennen die Eigenheiten und Originalprozesse aller Porsche-Generationen. Transparenter Ablauf, professionelle Abwicklung und das Ziel: Den Schaden weder sehen noch spüren."
          padding="py-24 px-4 lg:px-24"
          blocks={[
            {
              type: "heading",
              text: "Luftgekühlte Klassiker",
              level: 3,
            },
            {
              type: "paragraph",
              text: "911 F- & G-Modell, 964, 993 – wir kennen die besonderen Anforderungen und Originalprozesse der luftgekühlten Generationen.",
            },
            {
              type: "heading",
              text: "Moderne Porsche",
              level: 3,
            },
            {
              type: "paragraph",
              text: "996, 997, 991 (Carrera, Turbo, GT-Modelle), Boxster & Cayman – auch bei den wassergekühlten Modellen sind wir Spezialisten.",
            },
            {
              type: "heading",
              text: "So läuft Ihre Reparatur ab",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Schadensbegutachtung, Kostenvoranschlag, fachgerechte Reparatur nach Herstellervorgaben, Qualitätskontrolle, Übergabe – transparenter Prozess von A bis Z.",
            },
            {
              type: "component",
              component: "IconBulletListV2",
              props: {
                headline: "Warum Reparatur bei WTM?",
                items: [
                  "Reparatur nach Herstellervorgaben mit Originalteilen",
                  "Präzise Geometrieprüfung für perfekte Spaltmaße",
                  "Lückenlose Dokumentation aller Arbeitsschritte",
                  "Versicherter Hol- und Bringservice deutschlandweit",
                ],
                highlightedIndices: [0, 1],
                icon: "check",
              },
            },
            {
              type: "component",
              component: "CallToActionWithModalV2",
              props: {
                headline: "Reparatur anfragen – wir beraten Sie persönlich",
                paragraph:
                  "Schaden an Ihrem Porsche? Senden Sie uns Fotos und Beschreibung. Wir beraten Sie zu Reparaturmöglichkeiten und erstellen einen transparenten Kostenvoranschlag.",
                darkMode: false,
                margin: false,
              },
            },
          ]}
        />
      ),
      imageAlt: "WTM Sportwagen Porsche-Reparatur - Alle Modelle",
      navbarHeight: 0,
    },

    {
      type: "relevant-posts",
      postSlugs: [
        "porsche-elektronik-sensoren-fehlerquellen",
        "motorschaeden-vermeiden",
        "porsche-luftgekuehlte-inspektion-vs-serviceheft",
      ],
      headline: "Werkstatt Journal: Reparatur, Lack & Werterhalt",
      darkMode: false,
    },
  ],
};
